import { controls } from "../controls";

const ms67 = {
  label: "Qualification",
  pageLabel: "Qualification",
  starting: true,
  url: "ms67",
  bulk: { columns: ['code', 'description'] },
  formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({ tab: "filter", label: "Code", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "code", width: "col-sm-4", placeHolder: "Code" }),

    ...controls.displayText({ tab: "filter", label: "Description", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "description", width: "col-sm-4", placeHolder: "Description" }),


    //...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    //...controls.perPage({ tab: 'filter' }),
  ],
  form: [
    ...controls.displayText({ tab: "filter", label: "Code", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "code", width: "col-sm-4", placeHolder: "Code" }),

    ...controls.displayText({ tab: "filter", label: "Description", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "description", width: "col-sm-4", placeHolder: "Description" }),




  ],
  history: {
    perPage: 10,
    reportHeader: "Qualification",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      {
        Header: "Code",
        accessor: "cde",
      },
      {
        Header: "Description",
        accessor: "description",
      },
      
    ]
  }
};

export default ms67;